// Theme font constant
const themeFont = "'Plus Jakarta Display', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif";

export const globalStyles = {
  colors: {
    gray: {
      700: "#1f2733",
    },
    brand: {
      50: "#e0d6ff",
      100: "#b8a4ff",
      200: "#8b5cf6",
      300: "#7c3aed",
      400: "#6d28d9",
      500: "#5b21b6",
      600: "#4c1d95",
      700: "#3b0d7e",
      800: "#2e0a66",
      900: "#1e0042"
    },
    accent: {
      teal: "#14b8a6",
      cyan: "#06b6d4",
      purple: "#a855f7",
      pink: "#ec4899",
      orange: "#f97316",
      success: "#22c55e",
      warning: "#eab308",
      error: "#ef4444",
    },
  },
  styles: {
    global: (props) => ({
      body: {
        fontFamily: themeFont,
        scrollBehavior: "smooth",
      },
      "*::placeholder": {
        color: "gray.400",
      },
      /* Remove all focus outlines globally */
      "*:focus": {
        outline: "none !important",
        boxShadow: "none !important",
      },
      "*:focus-visible": {
        outline: "none !important",
        boxShadow: "none !important",
      },
      "button, a": {
        outline: "none !important",
      },
      "button:focus, button:active, a:focus, a:active": {
        outline: "none !important",
        boxShadow: "none !important",
      },
      html: {
        fontFamily: themeFont,
        scrollBehavior: "smooth",
      },
      /* Custom scrollbar styling */
      "::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
      },
      "::-webkit-scrollbar-thumb": {
        background: "linear-gradient(180deg, #8b5cf6 0%, #6d28d9 100%)",
        borderRadius: "10px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "linear-gradient(180deg, #a855f7 0%, #7c3aed 100%)",
      },
      /* Selection styling */
      "::selection": {
        background: "rgba(139, 92, 246, 0.3)",
        color: "white",
      },
      /* Global animations */
      "@keyframes fadeIn": {
        "from": { opacity: 0, transform: "translateY(10px)" },
        "to": { opacity: 1, transform: "translateY(0)" },
      },
      "@keyframes slideInLeft": {
        "from": { opacity: 0, transform: "translateX(-20px)" },
        "to": { opacity: 1, transform: "translateX(0)" },
      },
      "@keyframes slideInRight": {
        "from": { opacity: 0, transform: "translateX(20px)" },
        "to": { opacity: 1, transform: "translateX(0)" },
      },
      "@keyframes pulse": {
        "0%, 100%": { opacity: 1 },
        "50%": { opacity: 0.7 },
      },
      "@keyframes shimmer": {
        "0%": { backgroundPosition: "-200% 0" },
        "100%": { backgroundPosition: "200% 0" },
      },
      "@keyframes float": {
        "0%, 100%": { transform: "translateY(0)" },
        "50%": { transform: "translateY(-5px)" },
      },
      "@keyframes glow": {
        "0%, 100%": { boxShadow: "0 0 5px rgba(139, 92, 246, 0.5)" },
        "50%": { boxShadow: "0 0 20px rgba(139, 92, 246, 0.8)" },
      },
      "@keyframes spin": {
        "from": { transform: "rotate(0deg)" },
        "to": { transform: "rotate(360deg)" },
      },
      "@keyframes countUp": {
        "from": { opacity: 0, transform: "translateY(10px)" },
        "to": { opacity: 1, transform: "translateY(0)" },
      },
      "@keyframes bounceIn": {
        "0%": { transform: "scale(0.3)", opacity: 0 },
        "50%": { transform: "scale(1.05)" },
        "70%": { transform: "scale(0.9)" },
        "100%": { transform: "scale(1)", opacity: 1 },
      },
      "@keyframes gradientShift": {
        "0%": { backgroundPosition: "0% 50%" },
        "50%": { backgroundPosition: "100% 50%" },
        "100%": { backgroundPosition: "0% 50%" },
      },
    }),
  },
};
